import React, { Component } from "react";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStroopwafel } from "@fortawesome/free-solid-svg-icons";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { DateInput } from "semantic-ui-calendar-react";
import { Form, Container } from 'semantic-ui-react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./DateCustom.css"

import moment from "moment";

import help from "../assets/help.png";
import calendar from "../assets/calendar.ico";

// import ReactTooltip from "react-tooltip";

import {
  faAngleDown,
  faStopCircle,
  faCircle,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";
import { Icon, Menu, Popup } from "semantic-ui-react";
import colors from "../../colors";
// import {Link} from "react-router-dom";

library.add(faStroopwafel);
library.add(faAngleRight);
library.add(faAngleDown);
library.add(faStopCircle);
library.add(faCircle);
library.add(faDownload);

export default class TreeNode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: false,
      margin: props.margin,
      selected: false,
      color: props.color,
      prevColor: props.color,
      
      mn_selectedYear: "",
      mn_yrMonths: [],
      mn_selectedMonth: "",

      fn_selectedYear: "",
      fn_yrMonths: [],
      fn_selectedMonth: "",
      fn_yrMonFN: [],
      fn_selectedFN: "",
      product:"",
    };
  }
  onClick_meta = () => {
    this.props.updateMetaData();
  };
  
  onClick_print = () => {
    this.props.PrintOption();
  };

  onClick = () => {

    console.log(this.props.clickcount);

    if (this.props.clickcount === 0) {
      this.props.incrementCounter();
    } else {
      this.props.incrementCounter();
      this.props.handleTabClick(this.props.data.id);
    }


    this.setState({
      collapsed: !this.state.collapsed,
      color: !this.state.collapsed
        ? colors["sidebar-sub-menu"]
        : this.state.prevColor,
    });
  };

  onClickChild = () => {

//  let menu = this.props.parent
//       ? this.props.parent + "-" + this.props.data.name
//       : this.props.data.name;    // this.setState({selected:!this.state.selected})
//     console.log('DNAMe', this.props.data.name,menu);

    if (
      this.props.data.ismap &&
      this.props.selectedMenu !== this.props.data.name
    ) {
      this.props.toggleSelectedNodeStatus(this.props.data.name);
      this.props.setSelectedMenu(this.props.data.name);
      this.props.setSelectedLayer(this.props.data.name);

    }
  };

  mn_YearChange = (e) => {
    if (e.target.value !== '#') {
      this.mn_getMonths(e.target.value)
      this.setState({
        mn_selectedYear: e.target.value,
        fn_selectedFN:"",
        fn_selectedMonth:"",
        fn_selectedYear:"",
        mn_selectedMonth:"",
      })
    }
  }

  mn_MonthChange = (e) => {
    if (e.target.value !== '#') {
      // this.mn_getMonths(e.target.value)
      this.setState({
        mn_selectedMonth: e.target.value,
        fn_selectedFN:"",
        fn_selectedMonth:"",
        fn_selectedYear:"",

      })

      if(this.props.selectedMenu==="et-Evapotranspiration-Monthly750")
     
      {
        console.log("selected product in if ",this.props.selectedMenu)
        let product="AET"
        this.setState({
          product:product

        }) 
        console.log("selected product in if ",product)

        let find1 = this.props.monthly_dates.filter((item) => (item.year === this.state.mn_selectedYear && item.month === e.target.value));

        this.props.setSelectedMNLayer(find1[0].layerdate,product)
      //  let find1 = this.props.fortnightly_dates.filter((item) => (item.year === this.state.fn_selectedYear && item.month === this.state.fn_selectedMonth && item.fortnight === e.target.value));

     // this.props.setSelectedFNLayer(find1[0].layerdate, find1[0].fortnight,product)
       // console.log("selected product from product:",this.props.productselected)
      }

      if(this.props.selectedMenu!=="et-Evapotranspiration-Monthly750")
      {
        console.log("selected product elseif",this.props.selectedMenu)
        let product=(this.props.selectedMenu).split("-")[0].toUpperCase()
        this.setState({
          product:product

        }) 
        console.log("selected product elseif",product)

        let find1 = this.props.monthly_dates.filter((item) => (item.year === this.state.mn_selectedYear && item.month === e.target.value));

        this.props.setSelectedMNLayer(find1[0].layerdate,product)
      //  let find1 = this.props.fortnightly_dates.filter((item) => (item.year === this.state.fn_selectedYear && item.month === this.state.fn_selectedMonth && item.fortnight === e.target.value));

     // this.props.setSelectedFNLayer(find1[0].layerdate, find1[0].fortnight,product)
       // console.log("selected product from product:",this.props.productselected)
      }

    }
  }

  mn_getMonths = (e) => {
    // let mn_yrMonths = [];

    let find1 = this.props.monthly_dates.filter((item) => (item.year === e))
    
    console.log('MOnts', this.props.monthly_dates)
    console.log('Find', find1)

    this.setState({
      mn_yrMonths: find1
    })
  }

   fn_YearChange= (e) => {

    this.props.setSelectedFNLayer("", "")

    if (e.target.value !== '#') {
      this.fn_getMonths(e.target.value)
      this.setState({
        fn_selectedYear: e.target.value,
        fn_selectedFN:"",
        fn_selectedMonth:"",
        mn_selectedMonth:"",
        mn_selectedMonth:"",

      })
    }
  }

  fn_MonthChange = (e) => {
    this.props.setSelectedFNLayer("", "")
    
    if (e.target.value !== '#') {
      this.setState({
        fn_selectedMonth: e.target.value,
        fn_selectedFN:"",
        mn_selectedMonth:"",
        mn_selectedMonth:"",
      })
      this.fn_getFN(e.target.value)
    }
  }

  fn_getFN = (e) => {
    console.log('E', e)
    console.log('MOnts', this.props.fortnightly_dates)

    let find1 = this.props.fortnightly_dates.filter((item) => (item.year === this.state.fn_selectedYear && item.month === e))

    console.log('Find', find1)

    this.setState({
      fn_yrMonFN: find1
    })
  }



  fn_getMonths = (e) => {
    // let mn_yrMonths = [];
    let months = new Set();

    let find1 = this.props.fortnightly_dates.filter((item) => (item.year === e))

    find1.map((item) => {
      months.add(item.month);
    });
    
    console.log('MOnts', this.props.fortnightly_dates)
    console.log('Find', find1)

    this.setState({
      fn_yrMonths: Array.from(months)
    })
  }

  FNChange = (e) => {
    if (e.target.value !== '#') {
      // this.mn_getMonths(e.target.value)

      
      this.setState({
        fn_selectedFN: e.target.value,
       
        mn_selectedMonth:"",
        mn_selectedMonth:"",
      })
      if(this.props.selectedMenu==="et-Evapotranspiration-Fortnightly750")
      {
        console.log("selected product in if ",this.props.selectedMenu)
        let product="AET"
        this.setState({
          product:product

        }) 
        let find1 = this.props.fortnightly_dates.filter((item) => (item.year === this.state.fn_selectedYear && item.month === this.state.fn_selectedMonth && item.fortnight === e.target.value));

      this.props.setSelectedFNLayer(find1[0].layerdate, find1[0].fortnight,product)
        console.log("selected product from product:",this.props.productselected)
      }

      if(this.props.selectedMenu!=="et-Evapotranspiration-Fortnightly750")
      {
        console.log("selected product elseif",this.props.selectedMenu)
        let product=(this.props.selectedMenu).split("-")[0].toUpperCase()
        this.setState({
          product:product

        }) 
        let find1 = this.props.fortnightly_dates.filter((item) => (item.year === this.state.fn_selectedYear && item.month === this.state.fn_selectedMonth && item.fortnight === e.target.value));

      this.props.setSelectedFNLayer(find1[0].layerdate, find1[0].fortnight,product)
        console.log("selected product from product:",this.props.productselected)
      }
      
    }
  }

  componentDidMount() {
    if (this.props.data.hasDefault) {
      this.onClick();
    }
    if (
      this.props.selectedLayerLink === this.props.data.name ||
      this.props.data.default
    ) {
      this.onClickChild();
    }
    if (this.props.data.active) {
      this.onClick();
      this.onClickChild();
    }
  }
  
  openText = () => {
    this.props.EBPToggle(this.props.data.name);
  };

  render() {
    let subtree = null;
    console.log(" from et selectedmenu--------------",this.props.selectedMenu,this.props.monthly_yrs,this.state.mn_yrMonths,this.state.fn_yrMonFN,this.props.fortnightly_yrs)

    const { date, availableDates, handleDateChange } = this.props;

    // Convert available dates (if any) to Date objects for `react-datepicker`
    const enabledDates = availableDates.map((momentDate) => momentDate.toDate());
    console.log("available datesssssssssssssssssss,",enabledDates,"6666666666666666666666",availableDates)
    let fortnightYears, fnMonthsOpt, fnMonthFNOpt, mnYearsOpt, mnMonthsOpt, months;

    if (this.props.monthly_yrs) {
      mnYearsOpt = this.props.monthly_yrs.map((item) => {
        return (<option value={item}>{item}</option>)
      })
      console.log('MY1', mnYearsOpt);
    }

    // if (this.state.mn_yrMonths) {
    //   mnMonthsOpt = this.state.mn_yrMonths.map((item) => {
    //     return (<option value={item.month}>{item.month}</option>)
    //   })
    //   console.log('MYMN1', mnMonthsOpt);
    // }


    if (this.state.mn_yrMonths) {
      // Convert array to Set to remove duplicates, then convert it back to array
      const uniqueMonths = [...new Set(this.state.mn_yrMonths.map(item => item.month))];
      
      // Map the unique months to options
      mnMonthsOpt = uniqueMonths.map((month, index) => (
        <option key={index} value={month}>{month}</option>
      ));
    }

    if (this.state.fn_yrMonFN) {
      fnMonthFNOpt = this.state.fn_yrMonFN.map((item) => {
        return (<option value={item.fortnight}>{item.fortnight}</option>)
      })
      console.log('MYMN1', fnMonthFNOpt);
    }

    if (this.props.fortnightly_yrs) {
      fortnightYears = this.props.fortnightly_yrs.map((item) => {
        return (<option value={item}>{item}</option>)
      })
    }

    if (this.state.fn_yrMonths) {
      fnMonthsOpt = this.state.fn_yrMonths.map((item) => {
        return (<option value={item}>{item}</option>)
      })
      console.log('FNMN1', fnMonthsOpt);
    }
    console.log("dates for ddddddd-fortnightYears",fortnightYears,"dates for ddddddd-fnMonthsOpt",fnMonthsOpt,"dates for ddddddd-fnMonthFNOpt", fnMonthFNOpt,"dates for ddddddd  mnYearsOpt", mnYearsOpt,"dates for ddddddd mnMonthsOpt", mnMonthsOpt,"dates for ddddddd months", months)


    if (this.props.data.children) {
      subtree = this.props.data.children.map((child, key) => {
        return (
          <TreeNode
            key={key}
            data={child}
            EBPToggle={this.props.EBPToggle}
            setSelectedLayer={this.props.setSelectedLayer}
            setSelectedMenu={this.props.setSelectedMenu}
            margin={this.state.margin + 5}
            color={this.state.color}
            date={this.props.date}
            incrementCounter={this.props.incrementCounter}

            availableDates={this.props.availableDates}

            monthly_dates={this.props.monthly_dates}
            monthly_yrs={this.props.monthly_yrs}

            setSelectedMNLayer={this.props.setSelectedMNLayer}
            setSelectedFNLayer={this.props.setSelectedFNLayer}

            // mn_YearChange={this.props.mn_YearChange}
            
            mn_selectedYear={this.props.mn_selectedYear}
            mn_selectedMonth={this.props.mn_selectedMonth}
            fn_yrMonFN={this.state.fn_yrMonFN}

            fortnightly_dates={this.props.fortnightly_dates}
            fortnightly_yrs={this.props.fortnightly_yrs}

            fn_selectedYear={this.props.fn_selectedYear}
            fn_selectedMonth={this.props.fn_selectedMonth}
            fn_selectedFN={this.props.fn_selectedFN}

            active={this.props.active}

            handleDateChange={this.props.handleDateChange}
            selectedLayerLink={this.props.selectedLayerLink}
            toggleSelectedNodeStatus={this.props.toggleSelectedNodeStatus}
            selectedNodeStatus={this.props.selectedNodeStatus}
            selectedMenu={this.props.selectedMenu}
            updateMetaData={this.props.updateMetaData}
            PrintOption={this.PrintOption}
            modeChange={this.props.modeChange}
            inlinemode={this.props.inlinemode}
            handleTabClick={this.props.handleTabClick}

          />
        );
      });
    }

    if (subtree) {
      return (
        <div>
        <div
          class="grid-container"
          style={{
            background: colors["final_side"],
          }}
        >
          <div
            class="grid-child"
            style={{
              background: colors["final_side"],
              width: "210px",
              padding: "1px",
            }}
          >
                   <Menu.Item
            as="div"
            data-id={this.props.data.id}
            onClick={this.onClick}
            style={{ textAlign: "left", marginLeft: `${this.state.margin}px` }}
            disabled={this.props.data.disabled}
          >


            <div style={{ display: "flex" }}>
              <div
                style={{
                  width: "80%",
                  fontSize: !this.props.data.disabled ? "13px" : "unset",
                  color: !this.props.data.disabled ? colors.textcolor : "unset",
                  fontWeight: !this.props.data.disabled ? "bold" : "unset",
                }}
              >
                {this.props.data.displayname}
              </div>
              <div style={{ textAlign: "right", width: "20%" }}>
                {console.log(this.props.data.name, this.props.data.active)}
                {this.props.data.active ? (
                  <FontAwesomeIcon icon="angle-down" />
                ) : (
                    <FontAwesomeIcon icon="angle-right" />
                  )}
              </div>
            </div>
          </Menu.Item>
          </div>

          <div
            class="grid-child"
            style={{
              background: colors["final_side"],
              textAlign: "right",
              margin: "auto",
              color: colors.text_sub_color,
            }}
          >
          
          </div>
          </div>

          {this.props.active ? (
            <div style={{ background: colors.final_side_sub }}>{subtree}</div>
          ) : null}
         
        </div>

      );
      
    } else {

      return (
		<div>
			<div
				class="grid-container"
				style={{
					// background: colors["final_side"],
					background: colors["final_side_sub"],
				}}
			>
				<div
					class="grid-child"
					style={{
						background: colors["final_side_sub"],
						width: "210px",
						padding: "1px",
					}}
				>
					<Menu.Item
					  as="a"
					  data-id={this.props.data.id}
					  onClick={this.onClickChild}
					  style={{ textAlign: "left", color: colors.text_sub_color }}
					>
						<span style={{ padding: "1px" }}>
							{this.props.selectedNodeStatus[this.props.data.name] ? (
							  <FontAwesomeIcon icon="stop-circle" />
							) : (
							  <FontAwesomeIcon icon="circle" />
							)}
						</span>
						{this.props.data.displayname}
					</Menu.Item>
				</div>
				
				<div
					class="grid-child"
					style={{
					  background: colors["final_side"],
					  textAlign: "right",
					  margin: "auto",
					  color: colors.text_sub_color,
					}}
				>
					<div class="row">
  
					  {
						(this.props.data.displayname === 'Daily') ? (
						  <div class="column">
							{this.props.selectedNodeStatus[this.props.data.name] ? (
							  <Popup
								position="top right"
								onOpen={
								  this.props.modeChange
								}
								open={this.props.inlinemode}
								trigger={
								  <img
									src={calendar}
									width="20"
									height="20"
									align="right"
									alt="calendar"
								  ></img>
								}
								on="click"
							  > {this.props.inlinemode?
                
							

              <DatePicker
        selected={moment(date, "DD-MM-YYYY").toDate()} // Set selected date
        onChange={(date) => handleDateChange(null, { name: 'date', value: moment(date).format('DD-MM-YYYY') })}
        dateFormat="dd-MM-yyyy" // Set date format
        placeholderText="Select a date" // Set placeholder
       
        filterDate={(date) =>
          enabledDates.some((enabledDate) => enabledDate.toDateString() === date.toDateString())
        } // Enable only available dates
        inline // Display the calendar inline
        showPopperArrow={false} // Hide the arrow from the popup
        closeOnScroll={true} // Close the calendar when scrolling
        showMonthDropdown // Allow month selection
        showYearDropdown // Allow year selection
        scrollableYearDropdown 
        minDate={new Date(Math.min(...enabledDates.map((d) => d.getTime())))} // Set the minimum date
        maxDate={new Date(Math.max(...enabledDates.map((d) => d.getTime())))} // Set the maximum date
      />
               
                :null
                }
							  </Popup>
							) : null}
						  </div>
		  
						) : null
					  }  
                
					</div>

				</div>

			</div>
			
			{
				(this.props.data.displayname === 'Monthly') ? (
					<div class="grid-container"
					style={{
					  // background: colors["final_side"],
					  background: colors["final_side_sub"],
					}}>
					  {this.props.selectedNodeStatus[this.props.data.name] ? (
						<div className="month_yrs" style={{
						  // background: colors["final_side"],
						  marginLeft: '15px'
						}}>
              <div>
                <select value={this.state.mn_selectedYear} selected={this.state.mn_selectedYear} onChange={this.mn_YearChange}>
                  <option value="#" >Select Year</option>
                  {mnYearsOpt}
                </select>

              </div>
						  
						  <br />
						  <select selected={this.state.mn_selectedMonth} value={this.state.mn_selectedMonth} onChange={this.mn_MonthChange}>
                <option value="#">Select Month</option>
                {mnMonthsOpt}
						  </select>
						  
						</div>
					  ) : null}
					</div>

				) : null
			}  

			{
			  (this.props.data.displayname === 'Fortnightly') ? (
				<div class="grid-container"
				style={{
				  // background: colors["final_side"],
				  background: colors["final_side_sub"],
				}}>
				  {this.props.selectedNodeStatus[this.props.data.name] ? (
					<div className="fortnight_yrs" style={{
					  // background: colors["final_side"],
					  marginLeft: '15px'
					}}>
					  <select value={this.state.fn_selectedYear} selected={this.state.fn_selectedYear} onChange={this.fn_YearChange}>
              <option value="#" >Select Year</option>
              {fortnightYears}
					  </select>
					  <br />
					  <select selected={this.state.fn_selectedMonth} value={this.state.fn_selectedMonth} onChange={this.fn_MonthChange}>
              <option value="#">Select Month</option>
              {fnMonthsOpt}
					  </select>
					  <br />
					  <select selected={this.state.fn_selectedFN} value={this.state.fn_selectedFN} onChange={this.FNChange}>
              <option value="#">Select Fortnight</option>
              {fnMonthFNOpt}
					  </select>
					  
					</div>
				  ) : null}
				</div>

			  ) : null
			} 

		</div>
        

		);
    }
  }
}